var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6199 11.5298L9.60629 9.5162C8.73756 9.91174 7.79237 10.1111 6.83789 10.1C5.85382 10.1122 4.87992 9.89985 3.99029 9.479C3.3007 9.14255 2.68147 8.67787 2.16569 8.1098C1.61819 7.52291 1.18787 6.83681 0.897891 6.0884L0.837891 5.9L0.900891 5.7104C1.33458 4.60417 2.06444 3.6387 3.01049 2.9198L1.43789 1.3472L2.28569 0.5L12.4671 10.6814L11.6211 11.5298H11.6199ZM3.85949 3.7694C3.09265 4.30695 2.48708 5.04363 2.10809 5.9C2.92074 7.77494 4.79541 8.964 6.83789 8.9C7.46779 8.90516 8.09402 8.80373 8.69009 8.6L7.61009 7.52C7.36969 7.63784 7.10562 7.6994 6.83789 7.7C5.84637 7.69378 5.04411 6.89152 5.03789 5.9C5.03818 5.63166 5.09974 5.36693 5.21789 5.126L3.85949 3.7694ZM11.5491 8.066L10.7139 7.2314C11.0653 6.83415 11.3533 6.38507 11.5677 5.9C10.7561 4.02415 8.88074 2.83465 6.83789 2.9C6.68969 2.9 6.54089 2.9054 6.39689 2.9156L5.33789 1.8554C5.83087 1.74994 6.33376 1.69784 6.83789 1.7C7.82196 1.68779 8.79586 1.90017 9.68549 2.321C10.3751 2.65744 10.9943 3.12212 11.5101 3.6902C12.0573 4.27638 12.4876 4.96164 12.7779 5.7092L12.8379 5.9L12.7749 6.0896C12.494 6.82045 12.0784 7.49207 11.5497 8.0696L11.5491 8.066Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordHide);
export default __webpack_public_path__ + "static/media/password_hide.7d1cde4d1156b0bfeb5a5dbfd7905b4f.svg";
export { ForwardRef as ReactComponent };